import { Page } from '../../types'

const addRecoveredError: Page[] = [
    {
        pageType: 'information',
        title: 'Before you start',
        name: 'before-you-start',
        description:
            'Refers to the amount of error recovered within the given quarter. Entries should record the number of instances and the value of the loss relating to the error. Entries must include selections from the following typology dropdowns:'+
            '<ul><li>the business area in which the error occurred</li><li>the error origin - who was responsible for the initial mistake (error)?</li><li>the type of recovery that enabled the funds to be recovered</li><li>the extent of counter fraud resource involvement in the recovery of the error (this includes when counter fraud resource detected the error)</li><li>whether or not the error related to a COVID-19 scheme or activity</li></ul><br/>'
    },
    {
        pageType: 'question',
        title: 'Recovered error',
        name: 'recovered-error',
        description:
            'Refers to the amount of error recovered within the given quarter. Entries should record the number of instances and the value of the loss relating to the error. Entries must include selections from the following typology dropdowns:'+
            '<ul><li>the business area in which the error occurred</li><li>the error origin - who was responsible for the initial mistake (error)?</li><li>the type of recovery that enabled the funds to be recovered</li><li>the extent of counter fraud resource involvement in the recovery of the error (this includes when counter fraud resource detected the error)</li><li>whether or not the error related to a COVID-19 scheme or activity</li></ul><br/>',
        questions: [
            {
                questionType: 'radio',
                title: 'Do you have any instances of recovered fraud to declare?',
                name: 'recovered-error-declare',
                options: ['Yes', 'No'],
                rules: {
                    required: true
                }
            }
        ]
    },
    {
        pageType: 'list',
        title: 'Add another instance',
        name: 'recovered-error-add-instance',
        description:
            'Refers to the amount of error recovered within the given quarter. Entries should record the number of instances and the value of the loss relating to the error. Entries must include selections from the following typology dropdowns:'+
            '<ul><li>the business area in which the error occurred</li><li>the error origin - who was responsible for the initial mistake (error)?</li><li>the type of recovery that enabled the funds to be recovered</li><li>the extent of counter fraud resource involvement in the recovery of the error (this includes when counter fraud resource detected the error)</li><li>whether or not the error related to a COVID-19 scheme or activity</li></ul><br/>',
        disabled: [
            {
                field: 'recovered-error-declare',
                condition: 'equals', // optional
                value: 'No'
            }
        ],
        questions: [
            {
                questionType: 'select',
                title: 'Which spending area did the error occur in?',
                name: 'recovered-error-area',
                detailsHeading: 'Help with spending area',
                detailsContent: ' <b>Procurement:</b> Goods or services bought by public sector organisations (including suppliers)' +
                                ' <br/><b>Personnel:</b> Employees (including contractors and agency workers).' +
                                ' <br/><b>Subsidies:</b> Support or incentives given by the government.' +
                                ' <br/><b>Grants:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Loans & credit guarantees:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Charges & other non-tax income:</b> Money owed to public sector organisations (for example, court fines or prescription fees)' +
                                ' <br/><b>Licenses and permits:</b> Personal or business licenses (for example, a Blue Badge or Surveyor license)' +
                                ' <br/><b>Tax & Duties:</b> Mandatory government charge for goods, income or services' +
                                ' <br/><b>Benefits:</b> Money given by the government to support members of the public' +
                                ' <br/><b>Special Payments:</b> Money given in unique or specific circumstances (for example, compensation)',
                options: ['Procurement','Personnel','Subsidies','Grants','Loans & credit gurantees','Charges & other non-tax income','Licences and permits','Tax & Duties','Benefits','Special payments'],
                hintOption: 'Select an option',
                rules: {
                    required: true
                },
                errorMessages: { required: 'This field is mandatory' }
            },    
            {
                name: 'recovered-error-deception',
                questionType: 'radio',
                title: 'Who was responsible for the error?',
                // hint: 'Select one option',
                detailsHeading: 'Help with error origin',
                detailsContent: ' <b>Customer:</b> a member of the public or someone acting on behalf of a business or charity.'+
                                ' <br/><b>Supplier:</b> a person or business contracted to supply a service.' +                
                                ' <br/><b>Official:</b> a government department, public body or service.'+
                                ' <br/><b>Unknown:</b> I dont know who was responsible for the mistake?.',
                hintOption: 'Please Select',
                options: ['Customer', 'Supplier','Official','Unknown'],
                rules: {
                    required: true
                }
            },         
            {
                questionType: 'instanceInput',
                title: 'How many instances occurred?',
                name: 'recovered-error-impact',
                txt: `Total number of instances?`,
                rules: {
                    required: true
                }
            },
            {
                questionType: 'costInput',
                title: 'What was the value of the error?',
                name: 'recovered-error-estimated-total',
                txt: `Total value`,
                rules: {
                    required: false
                }
            },            
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'recovered-error-comments',
                hint: `Please ensure you do not include any personal or sensitive information`,
                rules: {
                    required: false
                }
            },   
            {
                questionType: 'checkbox',
                title: 'How was the error recovered (fully or partially)?',
                hint: `Tick all that apply`,
                detailsHeading: 'Help with recovery',
                detailsContent: '<b>Offsetting:</b> loss offset against their personal income (for example, salary or benefits).'+
                '<b>Voluntary repayment</b> the offender pays back the loss voluntarily.'+
                '<b>Through civil proceedings:</b> the offender is forced to pay back the loss because of civil proceedings.'+
                'Unknown: I dont know how it was recovered.',
                name: 'recovered-error-loss-recovered',
                options: ['Offsetting','Voluntary repayment','Through civil proceedings','Unknown'],
                rules: { required: true }
            }, 
            {
                questionType: 'radio',
                title: 'Does this relate to BAU or C19 activity?',
                hint: `You can tick both if applicable`,
                name: 'recovered-error-bau-c19',
                options: ['Business as usual (BAU)', 'Covid-19 (C19)'],
                rules: { required: true }
            }
        ]
    },
]
export default addRecoveredError
